import { defineMessages } from 'react-intl';

export default defineMessages({
    qualifyTextTitle: {
        id: 'twia.propertyDetails.views.messages.qualifyTextTitle',
        defaultMessage: 'To qualify, the building must meet one of the following Public Housing Authority Projects definitions:'
    },
    dewellingFirstMessage: {
        id: 'twia.propertyDetails.views.messages.dewellingFirstMessage',
        defaultMessage: 'Dwellings and apartments of Housing Projects owned by, supervised and maintained by Local Housing Authorities organized under the Housing Authority Law of the State of Texas as amended.'
    },
    dewellingSecondMessage: {
        id: 'twia.propertyDetails.views.messages.dewellingSecondMessage',
        defaultMessage: 'Dwellings and apartments of Housing Projects owned and supervised by Federal Housing Authorities.'
    },
    dewellingThirdMessage: {
        id: 'twia.propertyDetails.views.messages.dewellingThirdMessage',
        defaultMessage: 'Dwellings and apartments of similar apartment housing projects privately owned, built under and maintained under the supervision of and whose mortgages are insured by and rents controlled by the Federal Housing Administration.'
    },
    dewellingFourthMessage: {
        id: 'twia.propertyDetails.views.messages.dewellingFourthMessage',
        defaultMessage: 'Apartments (not dwellings or duplexes) of apartment house projects privately owned, when such projects consist of eight or more apartment units in one or more apartment buildings situated on the same premises.'
    }
});